import React from 'react';

const LOTUS_TONES = {
  pink:  ['#f59ab9', '#e04a86', '#a8134b'],
  gold:  ['#f5d27a', '#e0a92e', '#b87a12'],
  blue:  ['#f5d27a', '#3f7fd8', '#1f4fa8'],
  green: ['#9fd8a8', '#3fa35a', '#1b6e31'],
  saffron: ['#f7b267', '#f0802a', '#c2185b'],
};

// Lotus drawn pointing up with its base at the bottom-centre, so CSS
// rotations aim it into card corners / sideways without redrawing.
export const Lotus = ({ tone = 'pink' }) => {
  const [outer, inner, center] = LOTUS_TONES[tone] || LOTUS_TONES.pink;
  return (
    <svg viewBox="0 0 32 24" aria-hidden="true">
      <path d="M16 21C10 21 4 17 1.5 10.5C8 11 13 15 16 21Z" fill={outer} />
      <path d="M16 21C22 21 28 17 30.5 10.5C24 11 19 15 16 21Z" fill={outer} />
      <path d="M16 21C12 18 9.5 12 10.5 5.5C14.5 8.5 16.5 14 16 21Z" fill={inner} />
      <path d="M16 21C20 18 22.5 12 21.5 5.5C17.5 8.5 15.5 14 16 21Z" fill={inner} />
      <path d="M16 21C13 16 13 8 16 1.5C19 8 19 16 16 21Z" fill={center} />
      <path d="M8 22.5H24" stroke="#d4a017" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

// Small 4-point sparkle/diamond — used at both the frame's corners and its
// edge midpoints, matching the reference's plain gold sparkle (no leaf,
// flower, or squiggle line).
export const EdgeSpark = () => (
  <svg viewBox="0 0 16 16" aria-hidden="true">
    <path d="M8 0L9.5 6.5L16 8L9.5 9.5L8 16L6.5 9.5L0 8L6.5 6.5Z" fill="#d9a441" />
  </svg>
);

// Inline style (not CSS url(), which css-loader tries to resolve as a
// module import and fails the build for an absolute /public path) that
// clips .frame-photo-window's content to frame-mask.png's precise hole
// shape — same idea as <img src="/img/..."> referencing a public asset
// from JS rather than from a stylesheet.
//
// top/right/bottom/left inset .frame-photo-window to the frame's actual
// inner WINDOW rectangle (not the full canvas, and not the wider outer
// silhouette including the flared corner/side ornaments) — frame-mask.png
// itself is now cropped to that same window rectangle, at 1:1 scale, so
// mask and box always align exactly. Sizing/masking the photo to the
// wider silhouette instead (an earlier version of this) let a
// contain-fit photo render wider than the frame's true window, which the
// mask then clipped into — cutting off hands/shoulders at the sides. These
// percentages come from the window's own measured bbox within
// frame.png's current (content-cropped) canvas — recompute them if either
// asset is ever swapped for a differently-shaped frame.
export const FRAME_MASK_STYLE = {
  WebkitMaskImage: 'url(/img/frame-mask.png)',
  maskImage: 'url(/img/frame-mask.png)',
  top: '2.2715%',
  right: '6.2857%',
  bottom: '2.2161%',
  left: '5.7143%',
};

// Same idea, for the final/reveal page's own frame (public/img/final-frame.png),
// whose photo window is a different shape than the avatar-flow frame.png —
// notably much narrower relative to its canvas (the wide side ornaments
// flare out further past the window here than on frame.png).
export const FINAL_FRAME_MASK_STYLE = {
  WebkitMaskImage: 'url(/img/final-frame-mask.png)',
  maskImage: 'url(/img/final-frame-mask.png)',
  top: '9.1753%',
  right: '17.7143%',
  bottom: '5.5155%',
  left: '17.5714%',
};
